import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { Confetti } from '../effects/Confetti';
import type { Pet } from '../../types/pets';
import type { Item } from '../../types/items';

interface PurchaseSuccessModalProps {
  item: Pet | Item;
  onClose: () => void;
}

export function PurchaseSuccessModal({ item, onClose }: PurchaseSuccessModalProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-40">
      <Confetti active={true} />
      
      <div className="bg-gradient-to-br from-green-600 to-emerald-500 p-0.5 rounded-xl max-w-sm w-full animate-bounce-gentle">
        <div className="bg-gray-900 p-6 rounded-lg text-center">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-white mb-2">Purchase Complete!</h3>
          
          <div className="mt-4 p-4 bg-gray-800 rounded-lg">
            <img
              src={item.imageUrl}
              alt={item.name}
              className="w-32 h-32 object-cover rounded-lg mx-auto mb-2"
            />
            <p className="text-lg font-semibold text-white">{item.name}</p>
            <p className="text-sm text-gray-400 capitalize">
              {item.rarity} {('type' in item) ? item.type : ''}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}